import { NavigationArrow } from "@phosphor-icons/react";
import { Button } from "./ui/button";

/**
 * Opens Google Maps with driving directions to the given destination.
 *
 * Uses lat/lng when available (pin-accurate), falls back to the formatted address.
 * FREE - just a URL open, no API call cost.
 *
 * Props:
 *   address    - flat address string (fallback)
 *   latitude   - optional number
 *   longitude  - optional number
 *   variant    - "default" | "outline" | "ghost" (default: "outline")
 *   size       - "sm" | "default" (default: "sm")
 *   label      - override button text (default: "Get Directions")
 *   iconOnly   - boolean: render only the icon (for tight spaces)
 */
export default function GetDirectionsButton({
  address = "",
  latitude = null,
  longitude = null,
  variant = "outline",
  size = "sm",
  label = "Get Directions",
  iconOnly = false,
  className = "",
  "data-testid": testId = "get-directions-btn",
}) {
  const hasCoords = latitude != null && longitude != null;
  const hasAddress = !!address && address.trim().length > 0;
  if (!hasCoords && !hasAddress) return null;

  const destination = hasCoords
    ? `${latitude},${longitude}`
    : encodeURIComponent(address.trim());
  const url = `https://www.google.com/maps/dir/?api=1&destination=${destination}&travelmode=driving`;

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleClick}
      className={className}
      title={hasCoords ? "Opens Google Maps with pin-accurate directions" : "Opens Google Maps with address"}
      data-testid={testId}
    >
      <NavigationArrow size={14} className={iconOnly ? "" : "mr-1"} weight="fill" />
      {!iconOnly && label}
    </Button>
  );
}
